export default __webpack_public_path__ + "static/media/alert-info.1d1d10b7.svg";